import React, { useEffect } from 'react'
import styles from './style'
import propTypes from './prop'
import translator from 'src/translate'
import { Grid, withStyles, Checkbox } from '@material-ui/core'
import { PatchContent, PatchData } from 'src/model/patch'
import {
  QuestionFieldNames,
  SelectionFieldNames,
  AnswerItemType,
} from 'src/model/card'
import {
  cardSelectionPatchAction,
  cardSelectionDeleteAction,
} from 'src/reducers/card/action'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import { grey } from '@material-ui/core/colors'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import { Icon } from '@iconify/react'
import { CoreIconButton, CoreTextField } from 'src/components/core'
import { useSelector } from 'react-redux'
/**
 *
 * @param {*} props
 */

const KEY = 'theme'
const QuestionTestingSingleChoiceSelection = props => {
  const { classes, entity, dispatch, selection } = props
  const [isCorrect, setIsCorrect] = React.useState(selection.isCorrect)
  const [sText, setSText] = React.useState(selection.text)

  React.useEffect(() => {
    setIsCorrect(selection.isCorrect)
  }, [entity])

  let toggleButtons

  /**
   *
   * @param {*} isCorrect
   */
  const saveSelectionStatus = isCorrect => {
    setIsCorrect(isCorrect)
    dispatch(
      cardSelectionPatchAction(
        new PatchData(
          new PatchContent(
            isCorrect,
            SelectionFieldNames.ISCORRECT,
            PatchContent.OPERATION_REPLACE,
          ),
          selection[SelectionFieldNames.ID],
        ),
        entity[QuestionFieldNames.ID],
        () => {},
      ),
    )
  }
  const saveSelectionStatusSingleChoice = isCorrect => {
    setIsCorrect(isCorrect)
    //selection isCorrect = true ise once true olani patch e sok.
    if (isCorrect === true) {
      dispatch(
        cardSelectionPatchAction(
          new PatchData(
            new PatchContent(
              isCorrect,
              SelectionFieldNames.ISCORRECT,
              PatchContent.OPERATION_REPLACE,
            ),
            selection.id,
          ),
          entity[QuestionFieldNames.ID],
          () => {
            entity[QuestionFieldNames.SELECTIONS]
              .filter(x => x.id !== selection.id)
              .map(x =>
                dispatch(
                  cardSelectionPatchAction(
                    new PatchData(
                      new PatchContent(
                        false,
                        SelectionFieldNames.ISCORRECT,
                        PatchContent.OPERATION_REPLACE,
                      ),
                      x.id,
                    ),
                    entity[QuestionFieldNames.ID],
                    () => {},
                  ),
                ),
              )
          },
        ),
      )
    }
  }
  /**
   *
   * @param {*} e
   * @param {*} isCorrect
   */
  const handleChange = (e, isCorrect) => {
    if (
      isCorrect === true &&
      entity[QuestionFieldNames.QUESTION_TYPE] ===
        AnswerItemType.TESTINGSINGLECHOICE
    ) {
      saveSelectionStatusSingleChoice(isCorrect)
    } else if (isCorrect !== null) {
      saveSelectionStatus(isCorrect)
    }
  }

  /**
   *
   * @param {*} e
   */
  const handleTextChange = e => {
    setSText(e.target.value)
  }

  /**
   *
   * @param {*} e
   */
  const deleteButtonClickHandler = e => {
    const id = selection[SelectionFieldNames.ID]
    const questionId = selection[SelectionFieldNames.QUESTION_ID]

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              translator._('action.no'),
              ButtonActionType.NO,
              e => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              translator._('action.yes'),
              ButtonActionType.DELETE,
              e => {
                dispatch(messageBoxHideAction())

                dispatch(cardSelectionDeleteAction(id, questionId, () => {}))
              },
            ),
          ],
          title: translator._('message.delete'),
        }),
      ),
    )
  }

  /**
   *
   */
  const onBlur = () => {
    if (selection[SelectionFieldNames.STEXT] !== sText) {
      dispatch(
        cardSelectionPatchAction(
          new PatchData(
            new PatchContent(
              sText,
              SelectionFieldNames.STEXT,
              PatchContent.OPERATION_REPLACE,
            ),
            selection[SelectionFieldNames.ID],
          ),
          entity[QuestionFieldNames.ID],
          () => {},
        ),
      )
    }
  }

  let containerClass = classes.container
  if (
    entity[QuestionFieldNames.QUESTION_TYPE] ===
      AnswerItemType.TESTINGSINGLECHOICE ||
    entity[QuestionFieldNames.QUESTION_TYPE] ===
      AnswerItemType.TESTINGMULTIPLECHOICE
  ) {
    toggleButtons = (
      <Grid item className={classes.selectionsGridItem}>
        <Checkbox
          icon={<RadioButtonUncheckedIcon className={classes.checkboxIcon} />}
          checkedIcon={
            <RadioButtonCheckedIcon className={classes.checkBoxCheckedIcon} />
          }
          checked={isCorrect}
          onChange={handleChange}
          //color={'success'}
          className={classes.checkbox}
        />
      </Grid>
    )
  } else {
    toggleButtons = <div></div>
    containerClass = classes.containerNoGrid
  }
  const course = useSelector(state => state.course.course)
  const settingValue = course.settingDtos.find(x => x.key === KEY)?.value

  const [font, setFont] = React.useState(
    settingValue ? JSON.parse(settingValue).font : 'Inter',
  )
  useEffect(() => {
    setFont(settingValue ? JSON.parse(settingValue).font : 'Inter')
  }, [course])

  return (
    <Grid
      container
      alignItems="stretch"
      style={{ borderColor: grey[400] }}
      className={containerClass}
    >
      {toggleButtons}
      <Grid item alignItems="center" className={classes.gridItem}>
        <CoreTextField
          placeholder={translator._(
            'question.addQuestion.answerType.optionLabel',
          )}
          multiline
          value={sText}
          size="small"
          onChange={handleTextChange}
          onBlur={onBlur}
          fullWidth
          marginTop={false}
          fontFamily={font}
          InputProps={{
            classes: {
              notchedOutline: classes.noBorder,
              input: classes.input,
            },
          }}
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <CoreIconButton
          color="dark"
          onClick={deleteButtonClickHandler}
          size="small"
          variant="text"
          className={classes.iconButton}
        >
          <Icon icon="ic:round-close" />{' '}
        </CoreIconButton>
      </Grid>
    </Grid>
  )
}

QuestionTestingSingleChoiceSelection.propTypes = propTypes

export default withStyles(styles)(QuestionTestingSingleChoiceSelection)
